import styled from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { Button } from '../Button';
import { getEllipticableCss } from '../typography';

export interface SegmentedControlItemProps {
    checked?: boolean;
    disabled?: boolean;
    itemWidth?: 'evenly' | 'content';
}

export const SegmentedControlButton = styled(Button).attrs({
    size: 'small',
    type: 'submit',
})<SegmentedControlItemProps>`
    height: 100%;
    min-width: 0;
    border: none;
    overflow: auto;
    padding: 0 ${getSpacingToken('200')}px;

    ${({ itemWidth }) =>
        itemWidth === 'content'
            ? `
                flex: 0 0 auto; /* Distribution only relies on content width when itemWidth is 'content' */
               `
            : `
                flex: 1; /* Keep equal distribution when itemWidth is 'evenly' */
            `}

    &:disabled {
        background-color: ${getToken('backgroundInteractiveNeutralDefault')};
        color: ${getToken('textDisabled')};
    }

    &:not([disabled]) {
        background-color: ${({ checked }) =>
            getToken(checked ? 'backgroundStaticFlat' : 'backgroundInteractiveNeutralDefault')};

        &:hover {
            background-color: ${({ checked }) =>
                getToken(checked ? 'backgroundStaticFlat' : 'backgroundInteractiveNeutralHover')};
        }

        &:active {
            background-color: ${({ checked }) =>
                getToken(checked ? 'backgroundStaticFlat' : 'backgroundInteractiveNeutralActive')};
        }
    }

    & > * {
        ${getEllipticableCss({ ellipsis: true })};
    }
`;
